import React, { useState } from "react";
import {
  Modal,
  Descriptions,
  Input,
  Select,
  Form,
  message,
  Upload,
  Button,
  Switch,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";

const { Option } = Select;

const ProductDetail = ({ visible, onClose, product, onDelete, onUpdate }) => {
  const [editing, setEditing] = useState(false);
  const [form] = Form.useForm();
  const [thumbnailBase64, setThumbnailBase64] = useState(null);

  if (!product) return null;

  const handleEdit = () => {
    setEditing(true);
    form.setFieldsValue({
      brand_name: product.brand_name,
      product_title: product.product_title,
      product_price: product.product_price,
      product_link: product.product_link,
      exposure: product.exposure,
    });
  };

  const handleCancelEdit = () => {
    setEditing(false);
    setThumbnailBase64(null);
    form.resetFields();
  };

  const handleUpdate = async () => {
    try {
      const values = await form.validateFields();
      const updatedData = {
        ...values,
        product_thumbnail:
          thumbnailBase64 === null
            ? product.product_thumbnail
            : thumbnailBase64.split(",")[1],
        id: product.id,
      };
      onUpdate(updatedData);
      setEditing(false);
      setThumbnailBase64(null);
    } catch (error) {
      console.error(error);
      message.error("수정에 실패했습니다.");
    }
  };

  const handleThumbnailChange = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setThumbnailBase64(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <Modal
      title="상품 상세 정보"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      {!editing ? (
        <>
          <Descriptions bordered column={2}>
            <Descriptions.Item label="브랜드">
              {product.brand_name}
            </Descriptions.Item>
            <Descriptions.Item label="제품명">
              {product.product_title}
            </Descriptions.Item>
            <Descriptions.Item label="가격">
              {product.product_price}
            </Descriptions.Item>
            <Descriptions.Item label="제품 링크">
              <a
                href={product.product_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {product.product_link}
              </a>
            </Descriptions.Item>
            <Descriptions.Item label="썸네일" span={2}>
              <img src={product.product_thumbnail} alt="썸네일" width={300} />
            </Descriptions.Item>
            <Descriptions.Item label="상품 노출">
              {product.exposure ? "노출" : "숨김"}
            </Descriptions.Item>
            <Descriptions.Item label="판매중지 여부">
              {product.is_del ? "판매 중지" : "판매 중"}
            </Descriptions.Item>
            <Descriptions.Item label="생성일자">
              {product.created_at}
            </Descriptions.Item>
            <Descriptions.Item label="업데이트일자">
              {product.updated_at}
            </Descriptions.Item>
          </Descriptions>
          <div style={{ marginTop: "20px", textAlign: "right" }}>
            <Button
              type="primary"
              onClick={handleEdit}
              style={{ marginRight: 8 }}
            >
              수정
            </Button>
            <Button type="danger" onClick={() => onDelete(product.id)}>
              삭제
            </Button>
            <Button onClick={onClose}>닫기</Button>
          </div>
        </>
      ) : (
        <Form form={form} layout="vertical">
          <Form.Item
            name="brand_name"
            label="브랜드명"
            rules={[{ required: true, message: "브랜드명을 입력해주세요." }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="product_title"
            label="제품명"
            rules={[{ required: true, message: "제품명을 입력해주세요." }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="product_price"
            label="가격"
            rules={[{ required: true, message: "가격을 입력해주세요." }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="product_link"
            label="제품 링크"
            rules={[{ required: true, message: "제품 링크를 입력해주세요." }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="썸네일 업로드">
            <Upload
              beforeUpload={(file) => {
                handleThumbnailChange(file);
                return false;
              }}
              showUploadList={false}
            >
              <Button icon={<UploadOutlined />}>썸네일 선택</Button>
            </Upload>
            {thumbnailBase64 && (
              <img
                src={thumbnailBase64}
                alt="업로드된 썸네일"
                width={300}
                style={{ marginTop: "10px" }}
              />
            )}
          </Form.Item>
          <Form.Item name="exposure" label="상품 노출" valuePropName="checked">
            <Switch />
          </Form.Item>

          <div style={{ marginTop: "20px", textAlign: "right" }}>
            <Button
              type="primary"
              onClick={handleUpdate}
              style={{ marginRight: 8 }}
            >
              저장
            </Button>
            <Button onClick={handleCancelEdit}>취소</Button>
          </div>
        </Form>
      )}
    </Modal>
  );
};

export default ProductDetail;
